module.exports = __webpack_public_path__ + "img/Niro_Plug.ad88d47c.png";